import { defineStore } from 'pinia';
import moment from 'moment';
import { useShipmentStore } from './shipmentStore';

export const usePeriodStore = defineStore('periodStore', {
    state: () => {
        return {
            periods: [
                {
                    startDate: new Date(Date.now()),
                    endDate: null,
                }
            ],
            monthCount: [1],
        }
    },
    persist: {
        pick: ['periods', 'monthCount']
    },
    getters: {
        minPeriodStartDate: (state) => {
            let minDate = null;
            state.periods.forEach(period => {
                if (period.startDate) {
                    if (!minDate) {
                        minDate = period.startDate;
                    } else if (new Date(period.startDate) < new Date(minDate)) {
                        minDate = period.startDate;
                    }
                }
            });
            return minDate;
        },
        maxPeriodEndDate: (state) => {
            let maxDate = null;
            state.periods.forEach(period => {
                if (period.endDate) {
                    if (!maxDate) {
                        maxDate = period.endDate;
                    } else if (new Date(period.endDate) > new Date(maxDate)) {
                        maxDate = period.endDate;
                    }
                }
            });
            return maxDate;
        },
        validationMessage: (state) => {
            let message = "";

            const emptyPeriods = state.periods.filter(period => {
                return !period.startDate || !period.endDate;
            });

            if (emptyPeriods.length > 0) {
                message += "Please select start date and end date.<br>";
            }

            return message;
        },
    },
    actions: {
        setPeriods(payload) {
            this.periods = payload.periods;
        },
        setPeriodByIndex(payload) {
            const shipmentStore = useShipmentStore();
            this.periods[payload.index][payload.field] = payload.value;

            if (payload.field === 'startDate') {
                this.periods[payload.index]['endDate'] = null;
            }
            
            this.resetNextPeriods(payload.index);

            if (shipmentStore.shipment_type === 'delivery') {
                shipmentStore.setShipmentType('pickup');
            }
        },
        pushPeriod(payload) {
            this.periods.push(payload.period);
        },
        popPeriod() {
            if (this.periods.length > 1) {
                this.periods.pop();
            }
        },
        getPeriodDays(index) {
            let period = this.periods[index];
            if (period.startDate && period.endDate) {
                return moment(period.endDate).startOf('day').diff(moment(period.startDate).startOf('day'), 'days') + 1;
            }

            return 1;
        },
        getMinMaxPeriodDays() {
            let minStartDate = this.minPeriodStartDate;
            let maxEndDate = this.maxPeriodEndDate;
            if (minStartDate && maxEndDate) {
                return moment(maxEndDate).startOf('day').diff(moment(minStartDate).startOf('day'), 'days') + 1;
            }

            return 1;
        },
        resetNextPeriods(fromIndex) {
            for (let i = fromIndex + 1; i < this.periods.length; i++) {
                this.periods[i].startDate = null;
                this.periods[i].endDate = null;
            }
        },
        setEndDateByMonthCount(index) {
            let monthCount = this.monthCount[index];
            let startDate = this.periods[index].startDate ? moment(this.periods[index].startDate) : moment();
            let endDate = moment(startDate).add(monthCount, 'months').subtract(1, 'days');
            this.periods[index].endDate = endDate.toDate();
        },
    }
});